<script lang="ts">
      import { formatTime, getLocaleDay } from '$lib/utils/date'
      import { pad } from '$lib/utils/pad'
      import ImageElement from '../gallery/ImageElement.svelte'
      import LexicalRender from '../lexical/LexicalRender.svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import Button from '../ui/Button.svelte'
      import Tag from './Tag.svelte'
      import { addComma, authorAggregation, entityAggregation, getDateTime, renderEntity, roleAggregation } from './ts/Program'
      import { openLink } from './ts/utils'

      const locale = getLocaleContext()

      function replacePrice(price) {
            price = price.replace('*', '')
            if (locale.locale == 'en') return price.replace(/kč/i, 'Czk')
            return price
      }

      let { item } = $props()

      let _url = $derived(locale.getLocaleLink('/program/' + item.id))
</script>

<!--{#if item}-->
<a href={_url} class="newsItemContainer">
      <div class="programItem w-full h-full flex flex-col">
            <div class="w-full h-max aspect-[3/2]">
                  <ImageElement image={item.image ?? item.catalogue?.image ?? null} class="object-cover h-full w-full"></ImageElement>
            </div>

            <div class=" h-full min-h-[9rem] flex flex-col mt-auto px-6 md:px-8 pt-4 pb-8 bg-[#f2F2F2] item-body {item.catalogue?.program == 'accompanying' ? 'accomp' : ''}">
                  <div class="date font-['nunito-sans'] text-sm text-[#414141]">
                        <!--<p>{formatDate(item.value.createdAt)}</p>-->
                        <p class="text-sm">
                              <span class="uppercase">{getDateTime(item.datetime, item.runtime ?? 0, locale.locale)}</span> | {item.venue?.title ?? ''}
                              {#if item.price && item.price != '' && item.price != ' '}
                                    {@const price = replacePrice(item.price)}
                                    <span class="text-nowrap">
                                          {price != '' ? '| ' + item.price : ''}
                                    </span>
                              {:else if item.price && item.price == '*'}
                                    <span class="text-nowrap"></span>
                              {:else if !item.price || item.price == ''}
                                    <span class="text-nowrap">
                                          | {locale.ŧ({ default: 'volný vstup', en: 'free entry' })}
                                    </span>
                              {/if}
                        </p>
                  </div>
                  <div class="mt-2">
                        <p>{authorAggregation(item.catalogue?.author)}</p>
                        <h1 class="block text-xl text-accent">{locale.locale == 'cs' ? item.catalogue?.title_cs : item.catalogue?.title_en}</h1>
                        <p>{authorAggregation(item.catalogue?.theater)}</p>
                  </div>

                  <div class="flex gap-1 mt-1 flex-wrap">
                        {#each item.catalogue?.type as type, i (i)}
                              <Tag>{type.type}</Tag>
                        {/each}

                        {#each item.catalogue?.tags as tag, i (i)}
                              <Tag>{tag.tag}</Tag>
                        {/each}
                  </div>
                  <div class="content font-['nunito-sans'] text-[#414141]">
                        <LexicalRender root={locale.ŧ({ default: item.catalogue?.annotation_cs?.root, en: item.catalogue?.annotation_en?.root })}></LexicalRender>
                  </div>

                  <LexicalRender root={locale.ŧ({ default: item.note_before_cs?.root, en: item.note_before_en?.root })}></LexicalRender>
                  <LexicalRender root={locale.ŧ({ default: item.note_after_cs?.root, en: item.note_after_en?.root })}></LexicalRender>
                  {#if item.placeholderTicketsLink && item.showPlaceholderTicketsLink}
                        <div class="h-6"></div>
                        <div class="w-full mt-auto flex justify-center">
                              <Button
                                    onclick={async (ev) => {
                                          ev.preventDefault()
                                          ev.stopPropagation()
                                    }}
                                    type="button"
                                    variant="disabled"
                                    size="custom"
                                    class="w-full text-center">{item.placeholderTicketsLink}</Button>
                        </div>
                  {:else if item.ticketsLink && !item.hideTicketsLink && ! item.showPlaceholderTicketsLink}
                        <div class="h-6"></div>
                        <div class="w-full mt-auto flex justify-center">
                              <Button
                
                                    onclick={async (ev) => {
                                          ev.preventDefault()
                                          ev.stopPropagation()
                                          openLink(item.ticketsLink)
                                    }}
                                    type="button"
                                    variant="primary"
                                    size="custom"
                                    class="w-full text-center">{locale.ŧ({ default: 'vstupenky', en: 'tickets' })}</Button>
                        </div>
                  {/if}
            </div>
      </div>
</a>

<!--{/if}-->

<style lang="postcss">
      .programItem :global(.lexical-output) :global(p) {
            @apply text-base leading-[130%] font-primary;
            color: #414141;
      }

      .programItem {
            @apply flex-shrink rounded-xl overflow-hidden shadow-md;
            /*@apply flex-shrink border-[2px] border-[#00000044] rounded-xl;*/
            transition: transform 0.3s ease-in-out;

            /*box-shadow: 0px 2px 9px 0px #dedede33;*/
      }
      .newsItem:hover {
            transform: scale(1);
      }

      .newsItem h1 {
            transition: color 0.4s ease-in-out;
      }

      .newsItem:hover h1 {
            color: #00d314;
      }

      .newsItemContainer {
            @apply rounded-xl;
            box-shadow: 0 0px 20px 10px #8f8f8f1e;
      }

      .backdrop {
            /*background: rgb(255,255,255, 200);*/
            /*background: linear-gradient(0deg, rgba(255, 255, 255, 0.908) 97%, rgba(255, 255, 255, 0.117) 100%);*/
      }

      .item-body:global(.accomp) {
            @apply bg-[#FFFFFF] border-[1px];
      }
</style>
